var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embedContainer"},[_c('iframe',{attrs:{"id":"frame","src":_vm.embedLink,"title":_vm.embedTitle}})])}
var staticRenderFns = []

export { render, staticRenderFns }